// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__nz3vi","title":"style_title__JIUSZ","content":"style_content__8E4oz"};